import type { ListingsResponse } from '@/lib/collections/listings';

/**
 * Average number of standard 500ml PET bottles that make up roughly 1kg of
 * recovered plastic. Used only to translate a household's total recovered
 * weight into a relatable "items diverted from landfill" figure for the
 * impact summary — this is a computed estimate, not a real per-item count.
 */
export const ESTIMATED_ITEMS_PER_KG = 40;

export interface HouseholdImpactTotals {
  /** Sum of estimatedKg across the household's completed listings. */
  totalKg: number;
  /** Sum of estimatedValue (USDC cents) across completed listings, converted to USDC. */
  totalUsdcEarned: number;
  /** totalKg * ESTIMATED_ITEMS_PER_KG, rounded — an approximate item count. */
  itemsDiverted: number;
}

/** Computes real impact totals from a household's own completed listings. Never hardcode these numbers. */
export function computeHouseholdImpact(completedListings: ListingsResponse[]): HouseholdImpactTotals {
  const totalKg = completedListings.reduce((sum, listing) => sum + (listing.estimatedKg ?? 0), 0);
  const totalUsdcEarned = completedListings.reduce((sum, listing) => sum + (listing.estimatedValue ?? 0), 0) / 100;
  const itemsDiverted = Math.round(totalKg * ESTIMATED_ITEMS_PER_KG);
  return { totalKg, totalUsdcEarned, itemsDiverted };
}
